import React from 'react';
// src/components/Sections/ServicesSection.js
import { ServiceCard } from '../UI/ServiceCard.js';
import { services, additionalInfo } from '../../data/services.js';

const LAUNCH_PROMO_END_ISO = '2026-03-31T23:59:59-04:00';

export const ServicesSection = () => {
  const isLaunchPromoActive = Date.now() <= new Date(LAUNCH_PROMO_END_ISO).getTime();

  return React.createElement("section", {
    id: "services",
    className: "scroll-mt-24 py-20 md:py-24 bg-gradient-to-b from-gray-50 via-white to-slate-50"
  },
    React.createElement("div", {
      className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
    },
      React.createElement("h2", {
        className: "text-4xl font-bold text-center mb-6"
      }, "Services & Pricing"),
      React.createElement("p", {
        className: "text-gray-600 text-center mb-6 max-w-3xl mx-auto text-lg leading-relaxed"
      }, "Professional photography services tailored to capture your most precious moments"),
      isLaunchPromoActive
        ? React.createElement(React.Fragment, null,
            React.createElement("div", {
              className: "mb-4 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-4 text-center text-emerald-900 font-semibold"
            }, "Launch Promo: 20% OFF regular 1-hour sessions booked by March 31, 2026."),
            React.createElement("p", {
              className: "mb-10 text-center text-sm text-emerald-800"
            }, "Applies to portrait/equine/family style regular sessions. Excludes weddings, black background, and barn group sessions. Cannot be combined with other offers.")
          )
        : React.createElement("p", {
            className: "mb-10 text-center text-sm text-gray-600"
          }, "Ask about current seasonal offers when you inquire."),
      React.createElement("div", {
        className: "mb-10 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-center text-amber-900 font-medium"
      }, `Travel Policy: ${additionalInfo.travel}`),

      React.createElement("div", {
        className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
      }, services.map((service, index) =>
        React.createElement(ServiceCard, {
          key: index,
          service: service
        })
      )),

      // Additional Info Section
      React.createElement("div", {
        className: "mt-12 bg-gray-800 text-white rounded-2xl p-6 text-center"
      },
        React.createElement("h3", {
          className: "text-xl font-bold mb-4"
        }, "Booking Notes"),
        React.createElement("p", {
          className: "text-gray-300"
        }, "A signed agreement and retainer secure your date. Delivery timelines listed in each package are estimates and may vary slightly during peak season.")
      ),

      // Call to Action
      React.createElement("div", {
        className: "text-center mt-12"
      },
        React.createElement("a", {
          href: "#contact-form",
          className: "inline-block bg-gradient-to-r from-teal-500 to-cyan-600 text-white px-8 py-4 rounded-full font-semibold hover:from-teal-600 hover:to-cyan-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl text-lg"
        }, "Book Your Session Today")
      )
    )
  );
};